import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_VabeneAddSupplement = _resolveComponent("VabeneAddSupplement");
    return (_openBlock(), _createBlock(_component_VabeneAddSupplement, {
        action: _ctx.action,
        supplementID: _ctx.supplementID
    }, null, 8, ["action", "supplementID"]));
}
